import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { MaterialModule } from "@assoanalytics/app/material.module";

@Component({
  selector: "app-update-dialog",
  templateUrl: "./update-dialog.component.html",
  styleUrls: ["./update-dialog.component.scss"],
  standalone: true,
  imports: [MaterialModule],
})
export class UpdateDialogComponent {
  constructor(private dialogRef: MatDialogRef<UpdateDialogComponent>) {}

  update() {
    this.dialogRef.close("update");
  }

  later() {
    this.dialogRef.close("later");
  }
}
